// SettingsMenuSpeedProfileRange.js
import React, { useState } from "react";
import { Button, ColorPicker, For, HStack, Input, parseColor } from "@chakra-ui/react";
import { useAppStore } from "../../../context/store";
import { useMapObjects } from "../../../context/MapObjectsContext";
import { rgbaToHex, saveToCache } from "../../../utilies/Utility";
import { togglePolygonColors } from "../../../utilies/OsmUtility";

function SettingsMenuSpeedProfileRange() {
  const { mapObjects } = useMapObjects();

  const configSpeedProfile = useAppStore((s) => s.configSpeedProfile);
  const setConfigSpeedProfile = useAppStore.getState().setConfigSpeedProfile;

  const [isSpeedLimitToggled, setIsSpeedLimitToggled] = useState(false);

  const settingSpeedLimitToggle = () => {
    for (const key in mapObjects) {
      console.log(mapObjects[key].view_type);
      if (mapObjects[key].view_type == "lanelet") {
        const newToggle = !isSpeedLimitToggled;
        setIsSpeedLimitToggled(newToggle);
        togglePolygonColors(mapObjects[key].osmDataSource, configSpeedProfile, newToggle);
      }
    }

    saveToCache("setting_speed_limit", configSpeedProfile);
  };

  return (
    <>
      <For each={Object.entries(configSpeedProfile)}>
        {([key, item], index) => (
          <HStack gap={2} mb={2} justify={"space-between"} key={index}>
            <Input
              placeholder={"Range"}
              value={item.range}
              onChange={(v) => {
                setConfigSpeedProfile((prev) => prev.map((item2) => (item2.key === key ? { ...item2, label: v.target.value } : item2)));
              }}
            />
            <ColorPicker.Root
              defaultValue={parseColor(item.value)}
              onValueChange={(v) => {
                setConfigSpeedProfile((prev) => prev.map((item2) => (item2.key === key ? { ...item2, color: rgbaToHex(v.valueAsString) } : item2)));
              }}
            >
              <ColorPicker.HiddenInput />

              <ColorPicker.Control>
                <ColorPicker.Trigger />
              </ColorPicker.Control>

              <ColorPicker.Positioner>
                <ColorPicker.Content>
                  <ColorPicker.Area />
                  <HStack>
                    <ColorPicker.EyeDropper size="xs" variant="outline" />
                    <ColorPicker.Sliders />
                  </HStack>
                </ColorPicker.Content>
              </ColorPicker.Positioner>
            </ColorPicker.Root>
          </HStack>
        )}
      </For>

      <Button width={"full"} onClick={settingSpeedLimitToggle} colorPalette={isSpeedLimitToggled ? "green" : "black"}>
        {isSpeedLimitToggled ? "Disable" : "Enable"}
      </Button>
    </>
  );
}

export default SettingsMenuSpeedProfileRange;
